import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from '@ddt-web/dialog';

import { TourDialogContent } from '../../config';

@Component({
	templateUrl: './tour-dialog.component.html',
	styleUrls: ['./tour-dialog.component.scss']
})

export class TourDialogComponent implements OnInit {
	public stepIndex: number = 0;
	public stepButtonText: string[] = ['Back', 'Next', 'Done'];
	public tourDialogContent: TourDialogContent[];
	public featureName: string;

	constructor(public config: DialogConfig, private dialogRef: DialogRef) { }

	public ngOnInit(): void {
		this.tourDialogContent = this.config?.data?.tourDialogContent ?? [];
		this.featureName = this.config?.data?.featureName ?? '';
	}

	public onClose(shouldDisableBanner: boolean = false): void {
		this.dialogRef.close(shouldDisableBanner);
	}
}

